import { DocTypeEnum } from '@/constant';
import { RootState, WorkerChangeWorkPlaceSelectors } from '@/stores';
import { MyPageSelectors } from '@/stores/my-page';

import { memoize } from 'proxy-memoize';

import * as Config from './configs';

export const FORM_CONFIG_JSON = {
	/** WCF_02 */
	[DocTypeEnum.WC1_05]: Config.EMPLOYMENT_CHANGE_REPORT_CONFIG,
	/** FRF_03 */
	[DocTypeEnum.WC1_13]: Config.CONFIRM_EMPLOYER_PLACE_WORKER_CONFIG,
	/** WCF_01 */
	[DocTypeEnum.AM1_05]: Config.INTEGRATED_APPLICATION_CONFIG,
	/** FRF1_01 */
	[DocTypeEnum.AM1_06]: Config.STANDARD_LABOR_CONTRACT_CONFIG,
	/** WCF_01 */
	[DocTypeEnum.WC1_07]: Config.INTEGRATED_APPLICATION_CONFIG,
	[DocTypeEnum.AM1_08]: Config.DEDUCTION_AGREEMENT_CONFIG,
	// LMF_01
	[DocTypeEnum.AM1_09]: Config.RESIDENCE_CONFIG,
	/** FRF_05 */
	[DocTypeEnum.ES1_09]: Config.RENEW_STAY_APPLICATION_CONFIG,
	/** FRF_06 */
	[DocTypeEnum.ES1_10]: Config.RENEW_STAY_RECOMMENDATION_CONFIG,
	[DocTypeEnum.PM1_09]: Config.MARRIED_CONFIG,
	[DocTypeEnum.PM1_19]: Config.DOMESTIC_STAY_CONFIG,
	[DocTypeEnum.PM1_04]: Config.ATTRACTION_PLAN_CONFIG,
	[DocTypeEnum.PM1_10]: Config.ACCOMMODATION_CONFIG,

	// TODO: add config
	// [DocTypeEnum.PM1_03]: Config.RENEW_STAY_RECOMMENDATION_CONFIG,
	/** FRF_07 */
	[DocTypeEnum.PM1_13]:
		Config.CONFIRMATION_OF_SUBSCRIPTION_TO_AGRICULTURAL_AND_FISHERMAN_SAFETY_INSURANCE_CONFIG,
	[DocTypeEnum.PM2_22]: Config.PARTICIPATION_SEASONAL_WORK_CONFIG,
	[DocTypeEnum.PM2_23]:
		Config.SEASONAL_WORKER_RE_ENTRY_RECOMMENDATION_CONFIRMATION_CONFIG,
	// ARF_06
	[DocTypeEnum.PM2_24]: Config.FORM_HUMAN_TRAFFICKING_CONFIG,
	[DocTypeEnum.ES1_08]: Config.RENEW_STAY_RECOMMENDATION_CONFIG,
	[DocTypeEnum.AFR_04]: Config.MINISTRY_OF_JUSTICE_CONFIG,
	[DocTypeEnum.AFR_05]: Config.MINISTRY_OF_JUSTICE_PUBLIC_HEALTH_CONFIG,
	[DocTypeEnum.FRF_04]: Config.RECOMMENDATION_ENTRY_WORKER_CONFIG,
	[DocTypeEnum.FRF_08]:
		Config.EMPLOYER_DEDUCTION_POINTS_CALCULATION_STANDARDS_VIOLATE_THE_COMPLIANCE_CONTENTS_CONFIG,
	[DocTypeEnum.FRF_09]: Config.EMPLOYER_CERTIFICATE_OF_VIOLATION_CONFIG,
	[DocTypeEnum.FRF_10]: Config.ORGANIZATION_CERTIFICATE_OF_VIOLATION_CONFIG,
	[DocTypeEnum.FRF_11]: Config.ORGANIZATION_NOTICE_OF_VIOLATION_CONFIG,
	[DocTypeEnum.PMF_02]: Config.BUSINESS_AGREEMENT_CONFIG,
	[DocTypeEnum.LMF_04]: Config.ACCOMMODATION_FACILITIES_CONFIG,
	[DocTypeEnum.WCF_02]: Config.INTEGRATED_APPLICATION_CONFIG,
	[DocTypeEnum.AFR_07]:
		Config.LETTER_OF_REASON_FOR_INVITING_FOREIGN_LANGUAGE_ASSISTANT_CONFIG,
	[DocTypeEnum.ARF_08]: Config.CONSENT_TO_COLLECT_CONFIG,
	[DocTypeEnum.ARF_09]: Config.PARENTS_OF_INTERNATIONAL_STUDENTS_CONFIG,
	[DocTypeEnum.ARF_10]:
		Config.AGRICULTURAL_WORKPLACE_SAFETY_CHECKLIST_FOR_WORKERS_CONFIG,
	[DocTypeEnum.FRF_12]:
		Config.AGRICULTURAL_WORKPLACE_SAFETY_CHECKLIST_FOR_EMPLOYERS_CONFIG,
	[DocTypeEnum.ARF_11]: Config.MANDATORY_INSURANCE_CONSENT_CONFIG,
	[DocTypeEnum.ARF_12]: Config.ACCIDENT_INSURANCE_DEDUCTION_AGREEMENT_CONFIG,
	[DocTypeEnum.ARF_13]: Config.ACCIDENT_INSURANCE_COMMITMENT_CONFIG,
	[DocTypeEnum.FRF_13]: Config.WAGE_GUARANTEE_COMMITMENT_CONFIG,
	[DocTypeEnum.ARF_14]: Config.RECRUITING_FOREIGN_WORKER_CONFIG,
	[DocTypeEnum.ARF_15]:
		Config.INTRODUCTION_FOR_PARTICIPATION_IN_LABOR_UNION_CONFIG,
	[DocTypeEnum.ARF_16]: Config.EMPLOYER_PRIVACY_CONSENT_CONFIG,
};

export const REDUX_JSON = {
	[DocTypeEnum.PM1_10]: memoize((state: RootState) => ({
		unitInfo: state.fm1_01DefaultInfoUnit?.defaultInfoUnitDetail,
		adminInfo: state.myPage.dataMyPage,
	})),
	[DocTypeEnum.FRF_09]: memoize((state: RootState) => ({
		unitInfo: state.fm1_01DefaultInfoUnit?.defaultInfoUnitDetail,
		adminInfo: state.myPage.dataMyPage,
	})),
	[DocTypeEnum.WC1_05]: memoize((state: RootState) => ({
		workerChangeWorkPlaceDetail:
			state.workerChangeWorkPlace.workerChangeWorkPlaceDetail,
		workerUnauthorizedDeparture:
			state.workerUnauthorizedDeparture.workerUnauthorizedDepartureDetail,
	})),
	[DocTypeEnum.WC1_13]: memoize((state: RootState) => ({
		unitInfo: state.fm1_01DefaultInfoUnit?.defaultInfoUnitDetail,
		adminInfo: state.myPage.dataMyPage,
		workerChangeWorkPlaceDetail:
			state.workerChangeWorkPlace.workerChangeWorkPlaceDetail,
	})),
	[DocTypeEnum.PM1_19]: memoize((state: RootState) => ({
		unitInfo: state.fm1_01DefaultInfoUnit?.defaultInfoUnitDetail,
	})),
	[DocTypeEnum.PM1_13]: memoize((state: RootState) => ({
		unitInfo: state.fm1_01DefaultInfoUnit?.defaultInfoUnitDetail,
	})),
	[DocTypeEnum.PM1_09]: memoize((state: RootState) => ({
		unitInfo: state.fm1_01DefaultInfoUnit?.defaultInfoUnitDetail,
		recommender: state.workerApplicant.workerApplicantRecommender,
	})),
	[DocTypeEnum.ARF_09]: memoize((state: RootState) => ({
		unitInfo: state.fm1_01DefaultInfoUnit?.defaultInfoUnitDetail,
		recommender: state.workerApplicant.workerApplicantRecommender,
	})),
	[DocTypeEnum.WC1_07]: WorkerChangeWorkPlaceSelectors.selectDetail,
	[DocTypeEnum.AM1_05]: WorkerChangeWorkPlaceSelectors.selectDetail,
	[DocTypeEnum.WCF_02]: WorkerChangeWorkPlaceSelectors.selectDetail,
	[DocTypeEnum.PM1_04]: memoize((state: RootState) => ({
		unitInfo: state.fm1_01DefaultInfoUnit?.defaultInfoUnitDetail,
		franchiseStatus: state.workerProgram.franchiseStatus,
	})),
	[DocTypeEnum.ES1_10]: MyPageSelectors.selectDataMyPage,
	[DocTypeEnum.AFR_07]: memoize((state: RootState) => ({
		unitInfo: state.fm1_01DefaultInfoUnit?.defaultInfoUnitDetail,
		adminInfo: state.myPage.dataMyPage,
	})),
	[DocTypeEnum.PM2_23]: memoize((state: RootState) => ({
		adminInfo: state.myPage.dataMyPage,
		unitInfo: state.fm1_01DefaultInfoUnit?.defaultInfoUnitDetail,
		applicantAssignment: state.workerApplicant.workerApplicantAssignmentList,
	})),

	[DocTypeEnum.PMF_02]: memoize((state: RootState) => ({
		unitInfo: state.fm1_01DefaultInfoUnit?.defaultInfoUnitDetail,
	})),

	[DocTypeEnum.ES1_09]: memoize((state: RootState) => ({
		unitInfo: state.fm1_01DefaultInfoUnit?.defaultInfoUnitDetail,
	})),

	[DocTypeEnum.FRF_04]: memoize((state: RootState) => ({
		unitInfo: state.fm1_01DefaultInfoUnit?.defaultInfoUnitDetail,
	})),
	[DocTypeEnum.AM1_09]: memoize((state: RootState) => ({
		applicantList: state.workerLodging.applicantList,
	})),
	[DocTypeEnum.PM2_22]: memoize((state: RootState) => ({
		unitInfo: state.fm1_01DefaultInfoUnit?.defaultInfoUnitDetail,
	})),
	[DocTypeEnum.ARF_10]: memoize((state: RootState) => ({
		unitInfo: state.fm1_01DefaultInfoUnit?.defaultInfoUnitDetail,
	})),
	[DocTypeEnum.FRF_12]: memoize((state: RootState) => ({
		unitInfo: state.fm1_01DefaultInfoUnit?.defaultInfoUnitDetail,
	})),
	[DocTypeEnum.ARF_11]: memoize((state: RootState) => ({
		adminInfo: state.myPage.dataMyPage,
		unitInfo: state.fm1_01DefaultInfoUnit?.defaultInfoUnitDetail,
	})),
	[DocTypeEnum.ARF_16]: memoize((state: RootState) => ({
		adminInfo: state.myPage.dataMyPage,
		unitInfo: state.fm1_01DefaultInfoUnit?.defaultInfoUnitDetail,
	})),
	[DocTypeEnum.ARF_12]: memoize((state: RootState) => ({
		adminInfo: state.myPage.dataMyPage,
		unitInfo: state.fm1_01DefaultInfoUnit?.defaultInfoUnitDetail,
	})),
	[DocTypeEnum.ARF_13]: memoize((state: RootState) => ({
		unitInfo: state.fm1_01DefaultInfoUnit?.defaultInfoUnitDetail,
	})),
	[DocTypeEnum.FRF_13]: memoize((state: RootState) => ({
		unitInfo: state.fm1_01DefaultInfoUnit?.defaultInfoUnitDetail,
	})),
	[DocTypeEnum.ARF_14]: memoize((state: RootState) => ({
		unitInfo: state.fm1_01DefaultInfoUnit?.defaultInfoUnitDetail,
	})),
	[DocTypeEnum.ARF_15]: memoize((state: RootState) => ({
		unitInfo: state.fm1_01DefaultInfoUnit?.defaultInfoUnitDetail,
		recommender: state.workerApplicant.workerApplicantRecommender,
	})),
};

export const NEED_GET_FRANCHISE_DATA_DOCS: DocTypeEnum[] = [
	DocTypeEnum.AM1_06,
	DocTypeEnum.AM1_08,
	DocTypeEnum.WC1_13,
	DocTypeEnum.FRF_09,
	DocTypeEnum.FRF_10,
	DocTypeEnum.FRF_11,
	DocTypeEnum.LMF_04,
	DocTypeEnum.FRF_04,
	DocTypeEnum.ES1_09,
	DocTypeEnum.WC1_07,
	DocTypeEnum.AM1_05,
	DocTypeEnum.WCF_02,
	DocTypeEnum.PM2_23,
	DocTypeEnum.ES1_10,
	DocTypeEnum.WC1_05,
	DocTypeEnum.PM1_13,
	DocTypeEnum.AM1_09,
	DocTypeEnum.LMF_04,
	DocTypeEnum.FRF_12,
	DocTypeEnum.ARF_11,
	DocTypeEnum.ARF_12,
	DocTypeEnum.FRF_13,
	DocTypeEnum.ARF_14,
	DocTypeEnum.ARF_15,
];
export const NEED_GET_APPLICANT_DATA_DOCS: DocTypeEnum[] = [
	DocTypeEnum.PM1_19,
	DocTypeEnum.PM1_09,
	DocTypeEnum.AM1_06,
	DocTypeEnum.AM1_08,
	DocTypeEnum.FRF_04,
	DocTypeEnum.LMF_04,
	DocTypeEnum.AFR_04,
	DocTypeEnum.AFR_05,
	DocTypeEnum.AFR_07,
	DocTypeEnum.PM2_23,
	DocTypeEnum.ES1_10,
	DocTypeEnum.WC1_05,
	DocTypeEnum.AM1_09,
	DocTypeEnum.WC1_07,
	DocTypeEnum.AM1_05,
	DocTypeEnum.WCF_02,
	DocTypeEnum.PM2_22,
	DocTypeEnum.ARF_09,
	DocTypeEnum.ARF_10,
	DocTypeEnum.ARF_11,
	DocTypeEnum.ARF_12,
	DocTypeEnum.ARF_13,
	DocTypeEnum.FRF_13,
	// DocTypeEnum.ARF_14,
	DocTypeEnum.ARF_15,
];
export const NEED_GET_LODGING_DATA_DOCS: DocTypeEnum[] = [
	DocTypeEnum.LMF_04,
	DocTypeEnum.AFR_04,
	DocTypeEnum.AFR_05,
	DocTypeEnum.PM1_10,
	DocTypeEnum.WC1_07,
	DocTypeEnum.AM1_05,
	DocTypeEnum.WCF_02,
	DocTypeEnum.PM1_19,
	DocTypeEnum.AM1_09,
];

export const NEED_GET_LODGING_DATA_DOCS_WHEN_RELATED_INFO_HAS_LODGING_NON_FRANCHISE_AND_APPLICANT: DocTypeEnum[] =
	[DocTypeEnum.PM1_10];
export const NEED_GET_RECOMMENDER_DATA_DOCS: DocTypeEnum[] = [
	DocTypeEnum.PM1_09,
	DocTypeEnum.ARF_09,
	// DocTypeEnum.ARF_14,
	DocTypeEnum.ARF_15,
];
export const NEED_GET_PROGRAM_DATA_DOCS: DocTypeEnum[] = [DocTypeEnum.PM1_04];

export const NEED_GET_APPLICANT_LIST_DATA_DOCS: DocTypeEnum[] = [
	DocTypeEnum.ES1_09,
	DocTypeEnum.WC1_05,
];
